// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.

const lineHeights = {
  s: '1.10',
  m: '1.20',
  xs: '1.00',
  l: '1.40',
}

export default lineHeights
